module.exports = __webpack_public_path__ + "static/img/cover.5119060.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cover.png
// module id = qEfr
// module chunks = 94